import Vue from "vue";
import Lingallery from "./Lingallery.vue";

Vue.component("lingallery", Lingallery);

export default Lingallery;
